"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orto = {
    "name": "ORTOFOTOMAPA",
    "format": "image/jpeg",
    "tiles": {
        "EPSG_2180": [
            {
                "scaleDenominator": 7559523.809523809,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 1,
                    "height": 1
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 0
                    },
                    "col": {
                        "min": 0,
                        "max": 0
                    }
                }
            },
            {
                "scaleDenominator": 3779761.9047619044,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2,
                    "height": 2
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 1
                    },
                    "col": {
                        "min": 0,
                        "max": 1
                    }
                }
            },
            {
                "scaleDenominator": 1889880.9523809522,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 3,
                    "height": 3
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 2
                    },
                    "col": {
                        "min": 0,
                        "max": 2
                    }
                }
            },
            {
                "scaleDenominator": 944940.4761904761,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 6,
                    "height": 6
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 5
                    },
                    "col": {
                        "min": 0,
                        "max": 5
                    }
                }
            },
            {
                "scaleDenominator": 472470.23809523805,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 12,
                    "height": 11
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 10
                    },
                    "col": {
                        "min": 0,
                        "max": 11
                    }
                }
            },
            {
                "scaleDenominator": 236235.11904761902,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 23,
                    "height": 22
                },
                "limits": {
                    "row": {
                        "min": 1,
                        "max": 21
                    },
                    "col": {
                        "min": 1,
                        "max": 22
                    }
                }
            },
            {
                "scaleDenominator": 94494.04761904762,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 57,
                    "height": 54
                },
                "limits": {
                    "row": {
                        "min": 4,
                        "max": 53
                    },
                    "col": {
                        "min": 4,
                        "max": 56
                    }
                }
            },
            {
                "scaleDenominator": 47247.02380952381,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 114,
                    "height": 108
                },
                "limits": {
                    "row": {
                        "min": 9,
                        "max": 107
                    },
                    "col": {
                        "min": 9,
                        "max": 113
                    }
                }
            },
            {
                "scaleDenominator": 23623.511904761905,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 228,
                    "height": 215
                },
                "limits": {
                    "row": {
                        "min": 19,
                        "max": 214
                    },
                    "col": {
                        "min": 19,
                        "max": 227
                    }
                }
            },
            {
                "scaleDenominator": 9449.404761904761,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 569,
                    "height": 536
                },
                "limits": {
                    "row": {
                        "min": 47,
                        "max": 535
                    },
                    "col": {
                        "min": 47,
                        "max": 568
                    }
                }
            },
            {
                "scaleDenominator": 4724.702380952381,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 1137,
                    "height": 1071
                },
                "limits": {
                    "row": {
                        "min": 95,
                        "max": 1070
                    },
                    "col": {
                        "min": 95,
                        "max": 1136
                    }
                }
            },
            {
                "scaleDenominator": 1889.8809523809523,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2843,
                    "height": 2676
                },
                "limits": {
                    "row": {
                        "min": 239,
                        "max": 2675
                    },
                    "col": {
                        "min": 239,
                        "max": 2842
                    }
                }
            },
            {
                "scaleDenominator": 944.9404761904761,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 5685,
                    "height": 5352
                },
                "limits": {
                    "row": {
                        "min": 479,
                        "max": 5351
                    },
                    "col": {
                        "min": 479,
                        "max": 5684
                    }
                }
            },
            {
                "scaleDenominator": 472.4702380952381,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 11369,
                    "height": 10704
                },
                "limits": {
                    "row": {
                        "min": 959,
                        "max": 10703
                    },
                    "col": {
                        "min": 959,
                        "max": 11368
                    }
                }
            }
        ],
        "EPSG_4326": [
            {
                "scaleDenominator": 7559523.809523809,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2,
                    "height": 1
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 0
                    },
                    "col": {
                        "min": 0,
                        "max": 1
                    }
                }
            },
            {
                "scaleDenominator": 3779761.9047619044,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 3,
                    "height": 2
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 1
                    },
                    "col": {
                        "min": 0,
                        "max": 2
                    }
                }
            },
            {
                "scaleDenominator": 1889880.9523809522,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 6,
                    "height": 3
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 2
                    },
                    "col": {
                        "min": 0,
                        "max": 5
                    }
                }
            },
            {
                "scaleDenominator": 944940.4761904761,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 11,
                    "height": 6
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 5
                    },
                    "col": {
                        "min": 1,
                        "max": 10
                    }
                }
            },
            {
                "scaleDenominator": 472470.23809523805,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 21,
                    "height": 12
                },
                "limits": {
                    "row": {
                        "min": 1,
                        "max": 11
                    },
                    "col": {
                        "min": 2,
                        "max": 20
                    }
                }
            },
            {
                "scaleDenominator": 236235.11904761902,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 42,
                    "height": 24
                },
                "limits": {
                    "row": {
                        "min": 3,
                        "max": 23
                    },
                    "col": {
                        "min": 5,
                        "max": 41
                    }
                }
            },
            {
                "scaleDenominator": 94494.04761904762,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 105,
                    "height": 59
                },
                "limits": {
                    "row": {
                        "min": 8,
                        "max": 58
                    },
                    "col": {
                        "min": 14,
                        "max": 104
                    }
                }
            },
            {
                "scaleDenominator": 47247.02380952381,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 210,
                    "height": 117
                },
                "limits": {
                    "row": {
                        "min": 17,
                        "max": 116
                    },
                    "col": {
                        "min": 29,
                        "max": 209
                    }
                }
            },
            {
                "scaleDenominator": 23623.511904761905,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 419,
                    "height": 234
                },
                "limits": {
                    "row": {
                        "min": 35,
                        "max": 233
                    },
                    "col": {
                        "min": 58,
                        "max": 418
                    }
                }
            },
            {
                "scaleDenominator": 9449.404761904761,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 1048,
                    "height": 585
                },
                "limits": {
                    "row": {
                        "min": 87,
                        "max": 584
                    },
                    "col": {
                        "min": 146,
                        "max": 1047
                    }
                }
            },
            {
                "scaleDenominator": 4724.702380952381,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2095,
                    "height": 1169
                },
                "limits": {
                    "row": {
                        "min": 175,
                        "max": 1168
                    },
                    "col": {
                        "min": 292,
                        "max": 2094
                    }
                }
            },
            {
                "scaleDenominator": 1889.8809523809523,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 5237,
                    "height": 2922
                },
                "limits": {
                    "row": {
                        "min": 439,
                        "max": 2921
                    },
                    "col": {
                        "min": 731,
                        "max": 5236
                    }
                }
            },
            {
                "scaleDenominator": 944.9404761904761,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 10474,
                    "height": 5843
                },
                "limits": {
                    "row": {
                        "min": 879,
                        "max": 5842
                    },
                    "col": {
                        "min": 1463,
                        "max": 10473
                    }
                }
            }
        ]
    },
    "url": "http://mapy.geoportal.gov.pl/wss/service/WMTS/guest/wmts/ORTO"
};



//////////////////
// WEBPACK FOOTER
// ./src/capabilities/orto.ts
// module id = 277
// module chunks = 0 1